import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a190b35"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "E808ARenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击“展示图例”按钮，观察图例区出现的AB两个图例，在选项中选择与AB任意一个相同（包含旋转后）的选项", -1));
const _hoisted_5 = {
  class: "flex flex-col"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正确答案：", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您的答案：", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_CircleInTriangle = _resolveComponent("CircleInTriangle");
  const _component_el_button = _resolveComponent("el-button");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  const _component_el_tag = _resolveComponent("el-tag");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_4, _createElementVNode("span", null, "注意：每个题仅能查看一次图例，图例显示时间为 " + _toDisplayString($props.difficulty.flashInterval) + " 秒", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      class: "flex flex-col flex items-center justify-center"
    }, {
      default: _withCtx(() => [$data.visible == 1 ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        class: "flex flex-col flex items-center justify-center"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.questions, q => {
          return _openBlock(), _createBlock(_component_CircleInTriangle, {
            key: q,
            colors: q
          }, null, 8, ["colors"]);
        }), 128))]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        type: "primary",
        style: {
          "width": "100px"
        },
        disabled: $data.visible != 0,
        onClick: $options.showExample
      }, {
        default: _withCtx(() => [_createTextVNode("展示图例 ")]),
        _: 1
      }, 8, ["disabled", "onClick"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "flex items-center justify-center mt32"
      }, {
        default: _withCtx(() => [_createVNode(_component_AnswerButtonGroup, {
          onChoose: $options.onChoosed,
          "option-width": "140px",
          "option-both-center": false,
          review: $props.review,
          ref: "answerBtns",
          single: false,
          reviewMode: $props.reviewMode,
          options: $data.letters.slice(0, $props.data.answers.length)
        }, {
          default: _withCtx(btnIndex => [_createVNode(_component_CircleInTriangle, {
            colors: $props.data.answers[btnIndex.index]
          }, null, 8, ["colors"])]),
          _: 1
        }, 8, ["onChoose", "review", "reviewMode", "options"])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex items-center justify-center mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_col, {
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_hoisted_6, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.rightAnswers, (ra, rai) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          type: "info",
          style: {
            "width": "30px"
          },
          key: rai
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(ra), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }), $props.review ? (_openBlock(), _createBlock(_component_el_col, {
      key: 0,
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_hoisted_7, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.review.answer.split(','), (ra, rai) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          style: {
            "width": "30px"
          },
          type: $props.data.rightAnswers.indexOf(ra) >= 0 ? 'success' : 'danger',
          key: rai
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(ra), 1)]),
          _: 2
        }, 1032, ["type"]);
      }), 128))]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true)]);
}